import Immutable, { Map } from 'immutable'

const tourInitialState = new Map({
  tour_started: !localStorage.getItem('tour_finished'),
  tour_step: 0
})

const content = (state = new Map(), action) => {
  switch (action.type) {
    case 'content':
      return Immutable.fromJS(action.data)
    default:
      return state
  }
}

const session = (state = new Map(), action) => {
  switch (action.type) {
    case 'session':
      return Immutable.fromJS(action.data)
    default:
      return state
  }
}

const tour = (state = tourInitialState, action) => {
  switch (action.type) {
    case 'tour_step':
      return state.set('tour_step', action.step)
    case 'tour_finished':
      localStorage.setItem('tour_finished', true)
      return state.set('tour_started', false)
    default:
      return state
  }
}

export { content, session, tour }
